import React, {useEffect} from 'react';
import {Route, Redirect, useHistory, useLocation} from 'react-router-dom';
import {connect} from 'react-redux';

const PrivateRoute = ({children, auth, requiredPermission, ...rest}) => {
    const location = useLocation();

    return (
        <Route
            {...rest}
            render={({location}) => {
                if(!auth.isAuthenticated) {
                    return (
                        <Redirect
                            to={{
                                pathname: '/signin',
                            }}
                        />
                    )
                } else if(auth.permissions && requiredPermission && !auth.permissions.includes(requiredPermission)) {
                    return (
                        <Redirect
                            to={{
                                pathname: '/',
                            }}
                        />
                    )
                } else {
                    return children;
                }
            }}
        />
    );
};

const mapStateFromProps = ({ auth }) => ({
    auth,
});

export default connect(mapStateFromProps, null)(PrivateRoute);